import { defaultSchema } from '@atlaskit/adf-schema/schema-default';
import { type JSONDocNode, JSONTransformer } from '@atlaskit/editor-json-transformer';
import { WikiMarkupTransformer } from '@atlaskit/editor-wikimarkup-transformer';

const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
const adfTransformer = new JSONTransformer();

export const convertWikiToAdf = (wiki?: string | null): null | JSONDocNode => {
	if (wiki == null || wiki === '') {
		return null;
	}
	const pmNode = wikiTransformer.parse(wiki);
	return adfTransformer.encode(pmNode);
};

// the imports here were kept async so as not to blow the bundle sizes for everyone
export const convertWikiToAdfAsync = async (wiki?: string | null): Promise<JSONDocNode | null> => {
	if (wiki == null || wiki === '') {
		return Promise.resolve(null);
	}

	const wikiPromise = import(
		/* webpackChunkName: "async-wikimarkup-transformer" */ '@atlaskit/editor-wikimarkup-transformer'
	);
	const schemaPromise = import(
		/* webpackChunkName: "async-adf-defaultschema" */ '@atlaskit/adf-schema/schema-default'
	);
	const jsonPromise = import(
		/* webpackChunkName: "async-json-transformer" */ '@atlaskit/editor-json-transformer'
	);

	const [{ defaultSchema }, { WikiMarkupTransformer }, { JSONTransformer }] = await Promise.all([
		schemaPromise,
		wikiPromise,
		jsonPromise,
	]);

	const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
	const adfTransformer = new JSONTransformer();

	const pmNode = wikiTransformer.parse(wiki);
	return adfTransformer.encode(pmNode);
};
